var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Welcome to Introducer Sign Up")]),_c('p',[_vm._v("More information here")])])
}]

export { render, staticRenderFns }